// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"486":"83a2440a","9104":"f6f9b51e"}[chunkId] + ".chunk.css";
};